import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_MODELS
    FETCH_MODELS_SUCCESS
    FETCH_MODELS_FAILURE
`,
    {
        prefix: "carmodal/"
    }
);
